export const internet = {
  loginreq: "loginreq",
  no_loginreq: "no_loginreq",
  daddr: "daddr",
  pdaddr: "pdaddr",
  tdaddr: "tdaddr",
  wan_assign_dynamic: "wan_assign_dynamic",
  wan_assign_fixed: "wan_assign_fixed",
  wpethr: "wpethr",
  myip: "myip",
  mymask: "mymask",
  mygw: "mygw",
  pptp_dns_assign_auto: "dns_assign_auto",
  pptp_dns_assign_static: "dns_assign_static",
  primary_dns_address: "primary_dns_address",
  second_dns_address: "second_dns_address",
};

export default internet;
